import { useStreamSelection } from '@app/modules/logger/screens/stream/stores/useStreamSelection';
import { TranscriptonMenuView } from './TranscriptionMenuView';

export interface Props {
  start: number;
  end: number;
}

export function TranscriptonMenuContainer(p: Props) {
  const {
    clearSelection,
    canStartSelection,
    canEndSelection,
    setSelectionStart,
    setSelectionEnd,
    selection: { tsA, tsB },
  } = useStreamSelection();

  const allowStartSelection = canStartSelection(p.start);
  const allowEndSelection = canEndSelection(p.end);
  const allowClearSelection = Boolean(tsA || tsB);

  return (
    <TranscriptonMenuView
      startSelection={allowStartSelection ? () => setSelectionStart(p.start) : null}
      endSelection={allowEndSelection ? () => setSelectionEnd(p.end) : null}
      clear={allowClearSelection ? clearSelection : null}
    />
  );
}
